import React, { useCallback } from 'react';
import Text from 'design-system/Text';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectAlpacaAccountClosingInfo, selectAlpacaAccountClosingInfoIfSecclAccountActive, selectSecclAccountStatus, } from '../reducers/selectors';
import Links from '../../../utils/links';
import { isWeb } from '../../../constants';
export const useAlpacaClosingInfo = () => {
    const navigation = useMainStackNavigation();
    const secclAccountStatus = useAppSelector(selectSecclAccountStatus);
    const alpacaAccountClosingInfo = useAppSelector(selectAlpacaAccountClosingInfo);
    const alpacaAccountClosingInfoIfSecclAccountActive = useAppSelector(selectAlpacaAccountClosingInfoIfSecclAccountActive);
    const handleLearnMore = useCallback(() => {
        if (secclAccountStatus === 'NOT_STARTED') {
            navigation.navigateDeprecated('MigrationToSecclIntro');
            return;
        }
        Links.openLink('https://emma-app.com/learn-more/alpaca-to-seccl');
    }, [secclAccountStatus]);
    // Web never shows Alpaca accounts
    if (isWeb) {
        return null;
    }
    if (secclAccountStatus !== 'NOT_STARTED') {
        if (alpacaAccountClosingInfoIfSecclAccountActive) {
            return (<Text TextThin-14 Secondary>
          {alpacaAccountClosingInfoIfSecclAccountActive}{' '}
          <Text Text-14 Primary suppressHighlighting onPress={handleLearnMore}>
            Learn more
          </Text>
        </Text>);
        }
        return null;
    }
    if (!alpacaAccountClosingInfo) {
        return null;
    }
    return (<Text TextThin-14 Secondary>
      {alpacaAccountClosingInfo}{' '}
      <Text Text-14 Primary suppressHighlighting onPress={handleLearnMore}>
        Learn more
      </Text>
    </Text>);
};
